import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType, MatchType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';
import { KameleoonLogger } from 'src/logging';

export class Visits implements ICondition {
  private matchType?: MatchType | null;
  private conditionValue?: number | null;

  constructor({ matchType, visitCount }: ConditionDataType) {
    this.matchType = matchType;
    this.conditionValue = visitCount;
  }

  public evaluate({
    targetingData,
    sdkInfo,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const visitsData = targetingData?.[KameleoonData.VisitsData];

    if (!visitsData) {
      return Ok(false);
    }

    // --- Note ---
    // +1 is current visit for server sdk
    const visits = visitsData.visits.length + (sdkInfo.isServer ? 1 : 0);

    return Ok(this.checkCondition(visits));
  }

  private checkCondition(visitsAmount: number): boolean {
    if (!this.matchType || typeof this.conditionValue !== 'number') {
      return false;
    }

    switch (this.matchType) {
      case MatchType.EQUAL:
        return visitsAmount === this.conditionValue;
      case MatchType.GREATER:
        return visitsAmount > this.conditionValue;
      case MatchType.LOWER:
        return visitsAmount < this.conditionValue;
      default:
        KameleoonLogger.error`Unexpected comparing operation for Visits condition: ${this.matchType}`;
        return false;
    }
  }
}
